import { createSlice, configureStore } from "@reduxjs/toolkit";

import dbFirebase from "../firebase";

const prevsData = () => {
  let dataStored = [];
  dbFirebase.collection("expenses").onSnapshot((snapshot) => {
    dataStored = snapshot.docs.map((doc) => doc.data());
  });

  return dataStored;
};

const initialState = {
  switchNav: false,
  categoryFilterToggle: false,
  expenseList: prevsData(),
  searchString: "",
  categoryFilter: "",
};

const db = createSlice({
  name: "dbstore",
  initialState,
  reducers: {
    flipNav(state) {
      state.switchNav = !state.switchNav;
    },
    addExpense(state, action) {
      dbFirebase.collection("expenses").add(action.payload);
      state.expenseList = [...state.expenseList, action.payload];
    },
    deleteExpense(state, action) {
      dbFirebase.collection("expenses").doc(action.payload).delete();

      const delIndex = state.expenseList.findIndex(
        (exp) => exp.id === action.payload
      );
      state.expenseList.splice(delIndex, 1);
    },
    searchStringHandler(state, action) {
      state.searchString = action.payload;
    },
    sortByCategoryFilter(state, action) {
      state.categoryFilter = action.payload;
    },
    flipCategoryFilterToggle(state) {
      state.categoryFilterToggle = !state.categoryFilterToggle;
    },
  },
});

const store = configureStore({
  reducer: db.reducer,
});

export const rxDB = db.actions;

export default store;
